import { render, staticRenderFns } from "./headTop.vue?vue&type=template&id=5822bd24"
import script from "./headTop.vue?vue&type=script&lang=js"
export * from "./headTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports